<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->
<div class="wccard d-flex align-items-center mb-3">
    <span class="text-webbtree-green f-12 font-weight-500 ml-3 pointer" routerLink="/companypage"><i class="fa-solid fa-arrow-left mr-1"></i> Back</span>
    <div class="col-md-8  mx-auto text-center">
      <div>
    <div class="search-input-box position-relative">
        <input data-testid="auto-app-company-list-input-1" type="text" placeholder="Enter Company Name, Industry" (input)="onTypeAheadSearch($event, 'typeahead_search')" [formControl]="typeahead_search"
        [matAutocomplete]="company_name" (blur)="removeTypeahead('typeahead_search')">
        <div  *ngIf="showSearchLoader" class="spinner-border position-absolute text-black" style="top:18px; right: 60px; background-color: #fff;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <span class="search-btn pointer" (click)="searchCompanies()"><i class="fa-solid fa-search"></i></span>
      </div>
      <div class="search-history-btn">
        <span (click)="openSearchHistory()">Search History</span>
      </div>
        <mat-autocomplete #company_name="matAutocomplete">
          <div *ngIf="typeaheaddata?.length">
            <mat-option *ngFor="let data of typeaheaddata" [value]="data?.value" (onSelectionChange)="selectTypeahead(data)"
              class="my-1">
              <span class="d-flex align-items-center">
                <span>
                  <span class="compnaylogoplaceholder mr-2"
                    [ngClass]="{'bg-white': data?.companylogo , 'bg-color-company': !data?.companylogo}">
                    <img [src]="data?.companylogo" *ngIf="data?.companylogo" class="img-fluid" alt="">
                    <i class="fas fa-building f-12" *ngIf="!data?.companylogo"></i>
                  </span>
                </span>
                <span class="text-truncate">{{data.value | titlecase}}</span>
                <span class="ml-auto gray-text">
                  {{data?.type== 'name' ? 'Company': 'Industry'}}
                </span>
              </span>
            </mat-option>
          </div>
          <div *ngIf="!typeaheaddata?.length && recentSearchData.length" class="mt-2">
            <span class="f-12 text-9696 ml-3">Recent Searches</span>
            <mat-option *ngFor="let data of recentSearchData.slice(0,5)" (onSelectionChange)="selectRecentHistory(data)"
              class="my-1">
              <span class="d-flex align-items-center">
                <span>
                  <span class="compnaylogoplaceholder mr-2"
                    [ngClass]="{'bg-white': data?.companylogo , 'bg-color-company': !data?.companylogo}">
                    <img [src]="data?.companylogo" *ngIf="data?.companylogo" class="img-fluid" alt="">
                    <i class="fas fa-building f-12" *ngIf="!data?.companylogo"></i>
                  </span>
                </span>
                <span class="text-truncate">{{data?.name | titlecase}}</span>
                <span class="ml-auto gray-text">
                  {{(data?.type == 'company') ? 'Company': 'Industry'}}
                </span>
              </span>
            </mat-option>
          </div>
        </mat-autocomplete>
    </div>
    </div>
</div>
<div class="row">

    <div class="col pr-0" style="height: 100vh;">
      <form [formGroup]="companyfilter_form">
        <div class="wccard p-3" style="height: 100vh;">
            <div class="d-flex justify-content-between">
            <span class="f-18 font-weight-500"><i class="fa-regular fa-filters f-14"></i> Filter</span>
            <span class="f-12 font-weight-600 pointer text-webbtree-green" (click)="clearAll()">Reset</span>
        </div>
        <hr class="HR-seperator-in-card mx-0 mb-0">

          <div class="bb">
            <div class="" id="headingTwo">
              <h5 class="mb-0">
                <button data-testid="auto-app-company-list-button-1" class="btn px-0 py-3 collapsed f-14 w-100 text-black d-flex justify-content-between" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  <span class="font-weight-500"> Industries
               </span>
                  <span class="text-webbtree-green font-weight-500">
                    <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
                    <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
                  </span>
                </button>
              </h5>
            </div>

            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
              <div class="position-relative mb-3">
                <input data-testid="auto-app-company-list-input-2" class="wc-form-control" placeholder="Enter industry name" [matAutocomplete]="industry_name"
                  (input)="onTypeAheadSearch('industry', $event.target.value)" formControlName="industry" (click)="!industry_typeaheads.length && getFilterTypeaheads('industry','')" (blur)="removeTypeahead('industry')">
                  <div *ngIf="showIndustryLoader" class="spinner-border position-absolute text-black" style="top:8px; right: 8px; background-color: #fff;" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                <mat-autocomplete #industry_name="matAutocomplete"
                  (optionSelected)="selectOption($event.option.value, 'industry')">
                  <mat-option *ngFor="let industry of industry_typeaheads" [value]="industry" [matTooltip]="industry?.key | titlecase"  [matTooltipClass]="{ 'red-tooltip text-black': true }">{{industry?.key | titlecase}}<span>
                      </span>
                  </mat-option>
                </mat-autocomplete>

              </div>
              <div>
                <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let industry of selectedIndustries">
                  <div class="d-flex">
                    <span style="display: grid;">
                      <span class="text-truncate">
                        {{industry | titlecase}}
                      </span>
                    </span>

                    <span class="ml-2 pointer " (click)="unselect(industry, 'industry')">
                      <i class="fal fa-times"></i></span>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="bb">
            <div class="" id="headingThree">
              <h5 class="mb-0">
                <button data-testid="auto-app-company-list-button-2" class="btn px-0 py-3 collapsed f-14 w-100 text-black d-flex justify-content-between" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseThreee" aria-expanded="false" aria-controls="collapseThreee">
                  <span class="font-weight-500"> Company Size
               </span>
                  <span class="text-webbtree-green font-weight-500">
                    <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
                    <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
                  </span>
                </button>
              </h5>
            </div>

            <div id="collapseThreee" class="collapse" aria-labelledby="headingThree">
              <div class="position-relative mb-3">
                <input data-testid="auto-app-company-list-input-3" class="wc-form-control" placeholder="Enter Company size" [matAutocomplete]="company_size"
                  (input)="onTypeAheadSearch('companysize', $event.target.value)" formControlName="companysize" (click)="!companysize_typeaheads.length && getFilterTypeaheads('companysize','')" (blur)="removeTypeahead('companysize')">
                  <div *ngIf="showCompanysizeLoader" class="spinner-border position-absolute text-black" style="top:8px; right: 8px; background-color: #fff;" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                <mat-autocomplete #company_size="matAutocomplete"
                  (optionSelected)="selectOption($event.option.value, 'companysize')">
                  <mat-option *ngFor="let size of companysize_typeaheads" [value]="size" [matTooltip]="size?.key | titlecase"  [matTooltipClass]="{ 'red-tooltip text-black': true }">{{size?.key}}<span>
                      </span>
                  </mat-option>
                </mat-autocomplete>

              </div>
              <div>
                <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let size of selectedCompanysize">
                  <div class="d-flex">
                    <span style="display: grid;">
                      <span class="text-truncate">
                        {{size | titlecase}}
                      </span>
                    </span>

                    <span class="ml-2 pointer " (click)="unselect(size, 'companysize')">
                      <i class="fal fa-times"></i></span>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="bb">
            <div class="" id="headingFour">
              <h5 class="mb-0">
                <button data-testid="auto-app-company-list-button-3" class="btn px-0 py-3 collapsed f-14 w-100 text-black d-flex justify-content-between" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  <span class="font-weight-500">HQ Location
               </span>
                  <span class="text-webbtree-green font-weight-500">
                    <span class="test1"><i class="far fa-angle-up f-14 font-weight-500"></i></span>
                    <span class="test2"> <i class="far fa-angle-down font-weight-500 f-14"></i></span>
                  </span>
                </button>
              </h5>
            </div>

            <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
              <div class="position-relative mb-3">
                <input data-testid="auto-app-company-list-input-4" class="wc-form-control" placeholder="Enter HQ location" [matAutocomplete]="location_auto"
                  (input)="onTypeAheadSearch('location', $event.target.value)" formControlName="hqlocation" (click)="!hqlocations_typeaheads.length && getFilterTypeaheads('location','')" (blur)="removeTypeahead('location')">
                  <div *ngIf="showLocationLoader" class="spinner-border position-absolute text-black" style="top:8px; right: 8px; background-color: #fff;" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                <mat-autocomplete #location_auto="matAutocomplete"
                  (optionSelected)="selectOption($event.option.value, 'location')">
                  <mat-option *ngFor="let location of hqlocations_typeaheads" [value]="location" [matTooltip]="location?.key | titlecase"  [matTooltipClass]="{ 'red-tooltip text-black': true }">{{location?.key}}<span>
                      </span>
                  </mat-option>
                </mat-autocomplete>

              </div>
              <div>
                <span class="wc-ats-chip mr-2 mb-2 text-truncate" *ngFor="let location of selectedHqLocation">
                  <div class="d-flex">
                    <span style="display: grid;">
                      <span class="text-truncate">
                        {{location | titlecase}}
                      </span>
                    </span>

                    <span class="ml-2 pointer " (click)="unselect(location, 'location')">
                      <i class="fal fa-times"></i></span>
                  </div>
                </span>
              </div>
            </div>
          </div>

        </div>
      </form>

    </div>

    <div class="col-md-9">
        <div class="wccard p-3 mb-3 d-flex justify-content-between">
          <p class="f-16 font-weight-500">{{companycount | number}} Results Found</p>
          <!-- <span class="dropdown ats-dropBtn mx-1">
            <button data-testid="auto-app-company-list-button-4" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton"
              appDropdownToggle aria-haspopup="true" aria-expanded="false">
              <i class="far fa-sort-alt isActive mr-2"></i>Sort By
            </button>
            <div class="dropdown-menu" aria-labelledby="userDropdownButton">
              <a data-testid="auto-app-company-list-a-1" class="dropdown-item f-14" routerLinkActive="active"
                (click)="sortCompanies('nameasc')">Alphabetically: A-Z</a>
              <a data-testid="auto-app-company-list-a-2" class="dropdown-item f-14" routerLinkActive="active"
                (click)="sortCompanies('namedesc')">Alphabetically: Z-A</a>
            </div>
          </span> -->
        </div>
        <div class="row mr-0">

            <div class="col-md-4 mb-3 pr-0" *ngFor="let company of companylist">
              <!-- <div> -->
              <div class="newCompCard">
                <div class="compLogoIcon mb-2  bg-gray-new" [ngClass]="{'bg-white': company?.companylogo , 'bg-gray-new': !company?.companylogo}">
                  <span *ngIf="company?.companylogo; else showIcon;">
                      <img [src]="company?.companylogo" [alt]="company?.name">
                  </span>
                  <ng-template #showIcon>
                      <i class="fa-solid fa-buildings text-webbtree-green"></i>
                  </ng-template>
              </div>
                <div>
                    <p (click)="redirecttoCompanylist(company)" class="f-14 font-weight-500 black-text mb-1 d-grid pointer" matTooltip="{{company?.name | titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"> <span class="text-truncate text-capitalize">{{company?.name}}</span></p>
                    <p class="f-12 mb-2 d-grid"  matTooltip="{{company?.industry | titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }"> <span class="text-truncate text-capitalize">{{company?.industry}}</span></p>
                    <div class="f-12 text-9696 d-flex">
                        <span class="d-flex align-items-center"  matTooltip="{{company?.location?.name |titlecase}}" [matTooltipClass]="{ 'red-tooltip text-black': true }" *ngIf="company?.location?.name"><i class="fa-regular fa-buildings mr-1"></i><span class="d-grid"> <span class="text-truncate text-capitalize"> {{company?.location?.name}}</span></span></span>
                        <span *ngIf="company?.location?.name && company?.size"><i class="fal fa-horizontal-rule mx-2" style="transform: rotate(90deg);"></i></span>
                        <span class="d-flex align-items-center" style="width: 105px;" matTooltip="{{company?.size}}" [matTooltipClass]="{ 'red-tooltip text-black': true }" *ngIf="company?.size"><i class="fa-regular fa-users mr-1"></i><span class="d-grid" style="width: 105px;"><span class="text-truncate">{{company?.size}}</span></span></span>
                    </div>
                </div>
                <hr class="HR-seperator-in-card">
                <div *ngIf="company?.tags && company?.tags?.length">
                    <span class="tagslabel" *ngFor="let tag of company?.tags | slice: 0:2">
                        <span class="tagicon"><i class="fas fa-tag"></i></span>
                        <span class="d-grid" style="margin-bottom: 2px;"> <span matTooltip="{{tag}}" [matTooltipClass]="{ 'red-tooltip text-black': true }" class="text-truncate text-capitalize">{{tag}}</span></span>
                    </span>

                   <span class="f-10 text-webbtree-green pointer" (click)="redirecttoCompanylist(company)" *ngIf="company?.tags?.length - 2 > 0">+{{company?.tags?.length - 2}} More</span>
                </div>
            </div>
            <!-- </div> -->
          </div>

        </div>
        <p class="wccard text-center text-webbtree-green f-14 font-weight-500 mb-2 py-2" *ngIf= "companycount > 12"><span class="pointer" (click)="viewAllCompanyListing()">{{isViewMore ? 'View More' : 'View Less'}}</span></p>

    </div>
</div>
